import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss'],
})
export class PopupModalComponent implements OnInit {
@Input() allBanners:any[]

  constructor(private modalController: ModalController, private router: NavController) { }

  ngOnInit() {
    // if (this.isSquare ==  true) {
    //   this.sizeVar = "squareTrue"
    // } else {
    //   this.sizeVar = "squareFalse"
    // }
  }

  /**
   * Dismisses the modal.
   */
  async dismiss() {
    await this.modalController.dismiss();
  }

  /**
   * Handles the "Learn More" button click.
   * You can add navigation or other logic here.
   */
  learnMore() {
    console.log('Learn More button clicked!');
    // Example: You might want to dismiss the modal and then navigate
    this.dismiss();
    this.router.navigateRoot(['/subscription-list']);
  }
}